import React from "react";
import Form from "react-bootstrap/Form";
import {Table} from "../../../components/tables";
import {AuthRow} from "./AuthRow";

const componentName="Authorities";

const Authorities = ({authorities, onChange}) => {
	
	const isEmpty = require("is-empty");
	
	return ( 
		<Form>
	    	<Form.Label id={`${componentName}-authoritiesLabel`}>Authorities</Form.Label>
	    	<div className="mb-3 border overflow-x-hidden overflow-y-auto vh-70">
		    	<Table className="border-0 m-0">
		    		<thead>
		    			<tr>
							<th></th>
			    			<th className="text-center">Read</th>
			    			<th className="text-center">Write</th>                			
		    			</tr>
		    		</thead>
		    		<tbody>
					{
		            	!isEmpty(authorities) &&
		              	authorities.map((authority, idx) =>
		            			<React.Fragment key={`${authority.readMapping}-${authority.writeMapping}-${idx}`}> 
		                  			<AuthRow id={`${componentName}-authority`} idx={`${idx}`} authority={authority} onChange={onChange} readEnabled={true} writeEnabled={true}/>
									{
										!isEmpty(authority.subAuthorities) &&
		                				authority.subAuthorities.map((subAuthority, subIdx) =>
		                						<AuthRow id={`${componentName}-subAuthority`} idx={`${idx}-${subIdx}`} authority={subAuthority} onChange={onChange} readEnabled={authority.readGranted} writeEnabled={authority.writeGranted}
		                							key={`${subAuthority.readMapping}-${subAuthority.writeMapping}-${idx}-${subIdx}`}/>
		                				)
		                			}
		            			</React.Fragment>
						)
		            }
		    		</tbody>
		    	</Table>
	    	</div>
	    </Form>
	)
};

 export { Authorities };
